import { clientWithCredentials } from "../_helpers";
import { licenceConstants, alertConstants } from "../_constants";

export const licenceAction = {
    loadLicence,
    editLicence,
    createLicence
};

function loadLicence(id: any) {
    return function(dispatch:any) {
        dispatch({
            type: licenceConstants.LICENCE_LOADING
        });
        clientWithCredentials(dispatch).get(`api/licencetype/${id}`)
            .then((data) => {
                dispatch({
                    type: licenceConstants.LICENCE_LOADED,
                    data: data.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: licenceConstants.LICENCE_ERROR
                });
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.message,
                        level: "error"
                    }
                });
            })
    };
}

function editLicence(data: any) {
    return function(dispatch: any) {
        dispatch({
            type: licenceConstants.LICENCE_EDIT
        });
        clientWithCredentials(dispatch).post("api/licencetype", data)
        .then( dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: "licence_edited",
                        level: "notification"
                    }
                })
            )
            .catch((error) => {
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.message,
                        level: "error"
                    }
                });
            })

    }
}

function createLicence(data: any) {
    return function(dispatch: any) {
        dispatch({
            type: licenceConstants.LICENCE_CREATE
        });
        clientWithCredentials(dispatch).put("api/licencetype", data)
        .then( dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: "licence_created",
                        level: "notification"
                    }
                })
            )

            .catch((error) => {
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.response ? ( error.response.data ? error.response.data[0] : error ) : error,
                        level: "error"
                    }
                });
            })
    }
}